import Nullstack from 'nullstack';
export default function IconFirstAidKit({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-first-aid-kit",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 8v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "8",
    width: "16",
    height: "12",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M10 14h4"
  }), "   ", Nullstack.element("path", {
    d: "M12 12v4"
  }), " ");
}